import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";

const initialState = {
  guides: [],
  isLoading: false,
  error: false,
};

export const guideSlice = createSlice({
  name: "guide",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // GET Guides
    getGuidesSuccess(state, action) {
      state.isLoading = false;
      state.guides = action.payload;
    },

    // GET EspeceS
    getEspecesSuccess(state, action) {
      state.isLoading = false;
      state.especes = action.payload;
    },
    // create Guide
    createGuideSuccess(state, action) {
      state.guides.push(action.payload);
    },
    // update Guide
    updateGuideSuccess(state, action) {
      state.guides = state.guides.map((Guide) => {
        if (Guide.id === action.payload.id) {
          return action.payload;
        }
        return Guide;
      });
    },
    // delete Guide
    deleteGuideSuccess(state, action) {
      const { id } = action.payload;
      state.guides = state.guides.filter((Guide) => Guide.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getGuidesSuccess,
  createGuideSuccess,
  updateGuideSuccess,
  deleteGuideSuccess,
} = guideSlice.actions;

// create Guide function

export const createGuide = (data) => async (dispatch) => {
  const docRef = collection(firestore, "guid");
  const newData = {
    ...data,
    timestamp: serverTimestamp(),
  };
  try {
    dispatch(startLoading());
    const addedDocRef = await addDoc(docRef, newData);
    const id = addedDocRef.id;
    // Update the document with the ID
    const docToUpdate = doc(firestore, "guid", id);
    await updateDoc(docToUpdate, { id });
    dispatch(createGuideSuccess({ ...newData, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// get Guides

export const getGuides = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "guid"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getGuidesSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// update Guide

export const updateGuide = (data) => async (dispatch) => {
  const { id } = data;
  const docRef = doc(firestore, "guid", id);
  try {
    dispatch(startLoading());
    await updateDoc(docRef, { ...data, id });
    dispatch(updateGuideSuccess({ ...data, id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};
// delete Guide

export const deleteGuide = (id) => async (dispatch) => {
  const docRef = doc(firestore, "guid", id);
  try {
    dispatch(startLoading());
    await deleteDoc(docRef);
    dispatch(deleteGuideSuccess({ id }));
  } catch (error) {
    dispatch(hasError(error));
  }
};

export default guideSlice.reducer;
